import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { CdkPortal, PortalModule } from '@angular/cdk/portal';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, OverlayModule, PortalModule],
  template: `
  <ng-template cdkPortal>
    <div class="bg-white border rounded-lg shadow flex flex-col w-full p-4">
      <div class="flex justify-between w-full flex-wrap text-lg pb-2">
        <ng-content select="[my-dialog-header]"></ng-content>
        <!-- <button type="button" role="button" (click)="closeDialog.emit()">✖</button> -->
      </div>
      <div class="flex-1">
        <ng-content select="[my-dialog-body]"></ng-content>
      </div>
    </div>
  </ng-template>
  `,
  styles: []
})
export class DialogComponent {
  @ViewChild(CdkPortal) public readonly portal: CdkPortal | undefined;
  @Output() public readonly closeDialog = new EventEmitter<void>();

  private readonly overlayConfig = new OverlayConfig({
    hasBackdrop: true,
    positionStrategy: this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically(),
    scrollStrategy: this.overlay.scrollStrategies.block(),
    minWidth: 500,
  });
  private overlayRef = this.overlay.create(this.overlayConfig);

  constructor(private readonly overlay: Overlay) {
    this.overlayRef.backdropClick().subscribe(() => {
      this.closeDialog.emit();
    });
  }

  public ngAfterViewInit(): void {
    this.overlayRef?.attach(this.portal);
  }

  public ngOnDestroy(): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }
}
